import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            couponNameKo:'',
            couponNameEn:'',
            couponNameCn:'',
            couponDetailKo:'',
            couponDetailEn:'',
            couponDetailCn:'',
            couponBenefit:'',
            couponCount:'',
            files:[],
        }
    },
    validators: {
        couponNameKo: function (value) {
            return Validator.value(value)
                .required('쿠폰 이름을 입력해 주세요.')
        },
        couponNameEn: function (value) {
            return Validator.value(value)
                .required('쿠폰 이름을 입력해 주세요.')
        },
        couponNameCn: function (value) {
            return Validator.value(value)
                .required('쿠폰 이름을 입력해 주세요.')
        },
        couponDetailKo: function (value) {
            return Validator.value(value)
                .required('쿠폰 설명을 입력해 주세요.')
        },
        couponDetailEn: function (value) {
            return Validator.value(value)
                .required('쿠폰 설명을 입력해 주세요.')
        },
        couponDetailCn: function (value) {
            return Validator.value(value)
                .required('쿠폰 설명을 입력해 주세요.')
        },
        couponBenefit: function (value) {
            return Validator.value(value)
                .required('지급 KOIN을 입력해 주세요.')
                .custom(() => {
                    let num = /^[0-9_]+$/;
                    let match = value.match(num);
                    if(!match) {
                        return '숫자만 입력가능합니다.'
                    }
                    if(value <= 0){
                        return '1KOIN 이상 지급가능합니다.'
                    }
                })
        },
        couponCount: function (value) {
            return Validator.value(value)
                .required('발급 개수를 입력해 주세요.')
                .custom(() => {
                    let num = /^[0-9_]+$/;
                    let match = value.match(num);
                    if(!match) {
                        return '숫자만 입력가능합니다.'
                    }
                    if(value <= 0){
                        return '1개 이상 발급가능합니다.'
                    }
                })
        },
        files: function (value) {
            return Validator.value(value)
                .required('이미지를 선택해 주세요.')
        },
    }
}